import { ComponentStyleConfig } from '@chakra-ui/react';
import type { StyleFunctionProps, SystemStyleObject } from '@chakra-ui/theme-tools';
import { mode } from '@chakra-ui/theme-tools';

const TooltipTheme: ComponentStyleConfig = {
  baseStyle: (props: StyleFunctionProps): SystemStyleObject => ({
    backgroundColor: mode('black.base', 'black.lightest')(props),
    color: 'silver.light',
    borderRadius: '6px',
    border: mode('0.5px solid rgba(255, 255, 255, 0.12)', '0.5px solid rgba(255, 255, 255, 0.08);')(props),
    boxShadow: mode(
      '0px 0px 2px rgba(18, 21, 26, 0.08), 0px 2px 4px -1px rgba(18, 21, 26, 0.16)',
      '0px 0px 0px 0.5px rgba(18, 21, 26, 0.24);'
    )(props),
    fontWeight: 'md',
    textAlign: 'center',
    alignItems: 'center',
    maxWidth: '256px',
    padding: '8px 12px',
    size: 'sm'
  })
};

export default TooltipTheme;
